import React from 'react';
import PropTypes from 'prop-types';

class ProductCarousel extends React.Component {
  constructor(props) {
    super(props);
    this.state = { activeIndex: 0 };
    this.timer = null;
    this.goTo = this.goTo.bind(this);
    this.next = this.next.bind(this);
    this.pause = this.pause.bind(this);
    this.resume = this.resume.bind(this);
  }

  componentDidMount() {
    this.resume();
  }

  componentWillUnmount() {
    this.pause();
  }

  goTo(index) {
    this.setState({ activeIndex: index }, () => {
      this.resume();
    });
  }

  next() {
    const count = this.props.images.length;
    if (count < 2) return;
    this.setState(
      (prev) => ({
        activeIndex: (prev.activeIndex + 1) % count,
      }),
      () => {
        this.resume();
      }
    );
  }

  pause() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  resume() {
    this.pause();
    if (this.props.images.length < 2) return;
    this.timer = setInterval(this.next, this.props.interval);
  }

  render() {
    const { images } = this.props;
    const { activeIndex } = this.state;

    if (!images || images.length === 0) return null;

    return (
      <div
        className="product-page-carousel"
        onMouseEnter={this.pause}
        onMouseLeave={this.resume}
      >
        <div
          className="product-page-carousel-slides"
          onClick={this.next}
          role="button"
          tabIndex={0}
          onKeyDown={(evt) => {
            if (evt.key === 'Enter' || evt.key === ' ') {
              evt.preventDefault();
              this.next();
            }
          }}
          aria-label="Show next image"
        >
          {images.map((image, index) => (
            <img
              key={image.src}
              className={
                'product-page-carousel-img' +
                (index === activeIndex ? ' is-active' : '')
              }
              src={image.src}
              alt={image.alt}
            />
          ))}
        </div>
        {images.length > 1 && (
          <div className="product-page-carousel-dots" role="tablist">
            {images.map((image, index) => (
              <button
                key={image.src}
                type="button"
                role="tab"
                aria-label={`Show image ${index + 1}`}
                aria-selected={index === activeIndex}
                className={
                  'product-page-carousel-dot' +
                  (index === activeIndex ? ' is-active' : '')
                }
                onClick={() => this.goTo(index)}
              />
            ))}
          </div>
        )}
      </div>
    );
  }
}

ProductCarousel.defaultProps = {
  interval: 4000,
};

ProductCarousel.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      src: PropTypes.string.isRequired,
      alt: PropTypes.string,
    })
  ).isRequired,
  interval: PropTypes.number,
};

export default ProductCarousel;
